import React, {useContext, useEffect} from 'react';
import UserContext from 'UserContext';
import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'
import {navigate, Link} from '@reach/router';

export default props => {
  const {user, setUser} = useContext(UserContext);

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user]);

  return (
    <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header as='h2' color='teal' textAlign='center'>
          <Image src='/assets/images/logos/sayers-logo-small.jpg' /> Create an account
        </Header>
        <p>To request access, please <a href="http://www.sayersandpartners.co.uk/contact-us.html">contact Sayers and Partners</a></p>
        <Message>
          Already have an account? <Link to='/login'>Log in</Link>
        </Message>
      </Grid.Column>
    </Grid>
  );
};